import { MatTableDataSource } from '@angular/material/table';

export interface IMenu {
  id: number;
  name: string;
  originalId: number | null;
  language: string | null;
  happyHours: boolean;
  hidden: boolean;
  updatedAt: string;
  createdAt: string;
  processedAt: string | null;
  processingErrorMessage: string | null;
  processingErrorType: string | null;
  processingFailedAt: string | null;
  processingStartedAt: string | null;
  file: {
    id: number;
    name: string;
    url: string;
  } | null;
  icon?: string;
  banner?: string;
  pages: string[] | null;
  ownerType: 'CHAIN' | 'RESTAURANT';
}


export interface IMenuGroupTableData extends IMenu {
  translation: IMenu[] | MatTableDataSource<IMenu> | null;
}

export interface IMenuGroup extends IMenu {
  translation: IMenu[];
}

export interface IChainMenu {
  id: number;
  name: string;
  originalId: number | null;
  language: string | null;
  happyHours: boolean;
  hidden: boolean;
  updatedAt: string;
  createdAt: string;
  processedAt: string | null;
  processingErrorMessage: string | null;
  processingErrorType: string | null;
  processingFailedAt: string | null;
  processingStartedAt: string | null;
  file: MenuFile | null;
  icon?: string;
  banner?: string;
  pages: string[] | null;
  attachedRestaurantIds: number[] | null;
  attachedToAll: boolean;
  ownerType: 'CHAIN';
}

export interface UpdateChainMenuPayload {
  chainId: number;
  name: string;
  language: string | null;
  happyHours: boolean;
  hidden: boolean;
  restaurantIdsToAttach: number[] | null;
  pdfFileId?: string | null;
  iconFileId?: string | null;
  bannerFileId?: string | null;
}

export interface UpdateMenuPayload {
  name: string;
  language: string | null;
  happyHours: boolean;
  hidden: boolean;
  pdfFileId?: string | null;
  iconFileId?: string | null;
  bannerFileId?: string | null;
}

export interface MenuFile {
  id: number;
  name: string;
  url: string;
}

export interface IChainMenuGroupTableData extends IChainMenu {
  translation: IChainMenu[] | MatTableDataSource<IChainMenu> | null;
}

export interface IChainMenuGroup extends IChainMenu {
  translation: IChainMenu[];
}
